import React, { createContext, useContext, useState } from 'react';

const ThemeContext = createContext();

export const THEMES = {
  light: {
    name: 'Light',
    '--bg-primary': '#ffffff',
    '--bg-secondary': '#f8f9fa',
    '--bg-card': '#ffffff',
    '--bg-card-hover': '#f0f4ff',
    '--text-primary': '#1a1a2e',
    '--text-secondary': '#6c757d',
    '--accent': '#4361ee',
    '--accent-hover': '#3a56d4',
    '--accent-light': 'rgba(67, 97, 238, 0.1)',
    '--border': '#e9ecef',
    '--shadow': '0 4px 20px rgba(0, 0, 0, 0.08)',
    '--shadow-hover': '0 8px 30px rgba(67, 97, 238, 0.2)',
    '--header-bg': 'rgba(255, 255, 255, 0.85)',
    '--gradient-start': '#4361ee',
    '--gradient-end': '#7209b7',
    '--tag-bg': 'rgba(67, 97, 238, 0.1)',
    '--tag-text': '#4361ee',
    '--btn-text': '#ffffff',
  },
  dark: {
    name: 'Dark',
    '--bg-primary': '#0f0f1a',
    '--bg-secondary': '#1a1a2e',
    '--bg-card': '#16213e',
    '--bg-card-hover': '#1a2744',
    '--text-primary': '#e4e6eb',
    '--text-secondary': '#a0a3b1',
    '--accent': '#7c83ff',
    '--accent-hover': '#9ba1ff',
    '--accent-light': 'rgba(124, 131, 255, 0.15)',
    '--border': '#2a2a4a',
    '--shadow': '0 4px 20px rgba(0, 0, 0, 0.3)',
    '--shadow-hover': '0 8px 30px rgba(124, 131, 255, 0.25)',
    '--header-bg': 'rgba(15, 15, 26, 0.9)',
    '--gradient-start': '#7c83ff',
    '--gradient-end': '#e040fb',
    '--tag-bg': 'rgba(124, 131, 255, 0.15)',
    '--tag-text': '#7c83ff',
    '--btn-text': '#0f0f1a',
  },
  neon: {
    name: 'Neon',
    '--bg-primary': '#0a0a0a',
    '--bg-secondary': '#111111',
    '--bg-card': '#1a1a1a',
    '--bg-card-hover': '#222222',
    '--text-primary': '#f0f0f0',
    '--text-secondary': '#888888',
    '--accent': '#00ff88',
    '--accent-hover': '#00cc6a',
    '--accent-light': 'rgba(0, 255, 136, 0.1)',
    '--border': '#2a2a2a',
    '--shadow': '0 4px 20px rgba(0, 255, 136, 0.1)',
    '--shadow-hover': '0 0 30px rgba(0, 255, 136, 0.3), 0 0 60px rgba(0, 255, 136, 0.1)',
    '--header-bg': 'rgba(10, 10, 10, 0.95)',
    '--gradient-start': '#00ff88',
    '--gradient-end': '#00d4ff',
    '--tag-bg': 'rgba(0, 255, 136, 0.1)',
    '--tag-text': '#00ff88',
    '--btn-text': '#0a0a0a',
  },
};

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState('dark');

  const applyTheme = (themeName) => {
    setTheme(themeName);
    const root = document.documentElement;
    const themeVars = THEMES[themeName];
    Object.keys(themeVars).forEach((key) => {
      if (key.startsWith('--')) {
        root.style.setProperty(key, themeVars[key]);
      }
    });
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme: applyTheme, themes: THEMES }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
